module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/examples/notification-example/notification-example.component.scss
// module id = ./src/app/components/examples/notification-example/notification-example.component.scss
// module chunks = main